import { API_BASE, getApiHeaders } from './apiClient';

export interface Meeting {
  id: number;
  incidentId: string;
  title: string;
  scheduledAt: string;
  durationMinutes: number;
  invitees: { name: string; email: string; role: string }[];
  meetingLink: string | null;
  status: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED';
  notes: string | null;
  notesProcessed: boolean;
  createdAt: string;
}

async function apiFetch(url: string, opts?: RequestInit) {
  const res = await fetch(url, { ...opts, headers: { ...getApiHeaders(), ...(opts?.headers ?? {}) } });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export async function listMeetings(incidentId: string): Promise<Meeting[]> {
  const data = await apiFetch(`${API_BASE}/cima/incidents/${incidentId}/meetings`);
  return data.meetings ?? [];
}

export async function scheduleMeeting(incidentId: string, meeting: {
  title: string; scheduledAt: string; durationMinutes: number;
  invitees: { name: string; email: string; role: string }[];
  meetingLink?: string;
}): Promise<{
  meetingId: number;
  ics?: string;
  icsFilename?: string;
  /** Pre-filled SitRep+IAP XLSX (base64) — the UI triggers a local
   *  download so the CIMT Lead has the plan in hand immediately. */
  iapXlsx?: string;
  iapXlsxFilename?: string;
  iapActionCount?: number;
}> {
  return apiFetch(`${API_BASE}/cima/incidents/${incidentId}/meetings`, {
    method: 'POST', body: JSON.stringify(meeting),
  });
}

export async function updateMeeting(incidentId: string, meetingId: number, updates: {
  status?: string; notes?: string; meetingLink?: string;
}): Promise<void> {
  await apiFetch(`${API_BASE}/cima/incidents/${incidentId}/meetings/${meetingId}`, {
    method: 'PATCH', body: JSON.stringify(updates),
  });
}

export async function processNotes(incidentId: string, meetingId: number): Promise<any> {
  return apiFetch(`${API_BASE}/cima/incidents/${incidentId}/meetings/${meetingId}/process-notes`, {
    method: 'POST',
  });
}

export async function cancelMeeting(incidentId: string, meetingId: number): Promise<void> {
  await apiFetch(`${API_BASE}/cima/incidents/${incidentId}/meetings/${meetingId}`, {
    method: 'DELETE',
  });
}
